import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import db from "../firebase";

function AddData() {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    base: "",
    alcoholContent: "",
    carbonation: "",
    taste: "",
    recipe: [],
    ingredients: [],
  });
  const [image, setImage] = useState(null);
  const [ingredients, setIngredients] = useState([{ name: "", amount: "" }]);
  const [recipes, setRecipes] = useState([""]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleIngredientChange = (index, e) => {
    const { name, value } = e.target;
    const newIngredients = [...ingredients];
    newIngredients[index][name] = value;
    setIngredients(newIngredients);
  };

  const addIngredientField = () => {
    setIngredients([...ingredients, { name: "", amount: "" }]);
  };

  const removeIngredientField = (index) => {
    const newIngredients = ingredients.filter((_, i) => i !== index);
    setIngredients(newIngredients);
  };

  const handleRecipeChange = (index, value) => {
    const newRecipes = [...recipes];
    newRecipes[index] = value;
    setRecipes(newRecipes);
  };

  const addField = (setter, currentState) => {
    setter([...currentState, ""]);
  };

  const removeField = (setter, currentState, index) => {
    setter(currentState.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formattedIngredients = ingredients
      .filter(ing => ing.name && ing.amount)
      .map(ing => `${ing.name}-${ing.amount}`);

    try {
      await addDoc(collection(db, "items"), {
        ...formData,
        ingredients: formattedIngredients,
        recipe: recipes.filter(recipe => recipe.trim() !== ""),
        image: image,
      });

      setFormData({
        name: "",
        description: "",
        base: "",
        alcoholContent: "",
        carbonation: "",
        taste: "",
        recipe: [],
        ingredients: [],
      });
      setIngredients([{ name: "", amount: "" }]);
      setRecipes([""]);
      setImage(null);
      alert("データが追加されました！");
    } catch (error) {
      console.error("エラー:", error);
    }
  };

  const baseOptions = [
    "ジン", "ウイスキー",
   
    "ウォッカ",
    "ラム",
    "テキーラ",
    "日本酒",
    "焼酎",
  ];
  const alcoholContentOptions = ["低", "中", "高", "無"];
  const carbonationOptions = ["有", "無"];
  const tasteOptions = [
    "甘口",
    "中辛",
    "辛口",
    "爽やか",
    "さっぱり",
    "フルーティー",
    "ほろ苦い",
  ];

  return (
    <form className="form-style" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
      <input
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="カクテルの名前"
        required
        style={{ padding: '10px' }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
        <label htmlFor="file-upload" className="custom-file-upload" style={{ cursor: 'pointer', padding: '10px', backgroundColor: '#f0f0f0', borderRadius: '5px' }}>
          画像を選択
        </label>
        <input
          id="file-upload"
          type="file"
          onChange={handleImageChange}
          accept="image/*"
          style={{ display: "none" }}
        />
        <div style={{ width: '200px', height: '200px', border: '2px dashed #ccc', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
          {image ? (
            <img
              src={image}
              alt="プレビュー"
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />
          ) : (
            <span style={{ color: '#999' }}>画像プレビュー</span>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', margin: '0 20px' }}>
        <select
          name="base"
          value={formData.base}
          onChange={handleChange}
          required
          style={{ padding: '10px', flex: 1 }}
        >
          <option value="">ベースのお酒を選択</option>
          {baseOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select
          name="alcoholContent"
          value={formData.alcoholContent}
          onChange={handleChange}
          required
          style={{ padding: '10px', flex: 1 }}
        >
          <option value="">アルコール度数を選択</option>
          {alcoholContentOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select
          name="carbonation"
          value={formData.carbonation}
          onChange={handleChange}
          required
          style={{ padding: '10px', flex: 1 }}
        >
          <option value="">炭酸の有無を選択</option>
          {carbonationOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select
          name="taste"
          value={formData.taste}
          onChange={handleChange}
          required
          style={{ padding: '10px', flex: 1 }}
        >
          <option value="">味を選択</option>
          {tasteOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <h3>説明</h3>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="説明を入力"
          rows="3"
          style={{ width: '90%', padding: '5px' }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <h3>材料</h3>
        {ingredients.map((ingredient, index) => (
          <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <input
              type="text"
              name="name"
              value={ingredient.name}
              onChange={(e) => handleIngredientChange(index, e)}
              placeholder="材料名"
              style={{ padding: '5px' }}
            />
            <input
              type="text"
              name="amount"
              value={ingredient.amount}
              onChange={(e) => handleIngredientChange(index, e)}
              placeholder="量（例：30ml）"
              style={{ padding: '5px' }}
            />
            {index > 0 && (
              <button type="button" onClick={() => removeIngredientField(index)} style={{ padding: '5px 10px' }}>-</button>
            )}
          </div>
        ))}
        <button type="button" onClick={addIngredientField} style={{ padding: '5px 10px', marginTop: '10px' }}>+</button>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <h3>作り方</h3>
        {recipes.map((recipe, index) => (
          <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', width: '90%' }}>
            <textarea
              value={recipe}
              onChange={(e) => handleRecipeChange(index, e.target.value)}
              placeholder="作り方を入力"
              rows="2"
              style={{ width: '100%', padding: '5px' }}
            />
            {index > 0 && (
              <button 
                type="button" 
                onClick={() => removeField(setRecipes, recipes, index)}
                style={{ padding: '5px 10px' }}
              >
                -
              </button>
            )}
          </div>
        ))}
        <button 
          type="button" 
          onClick={() => addField(setRecipes, recipes)}
          style={{ padding: '5px 10px', marginTop: '10px' }}
        >
          +
        </button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button type="submit" style={{ padding: '10px 20px', cursor: 'pointer', fontSize: '16px' }}>追加</button>
      </div>
    </form>
  );
}

export default AddData;
